import debug from 'debug';

/***
 * Creates a debug logger for the application.
 * The logger will be namespaced with the provided namespace.
 * * @param namespace - The namespace for the logger, e.g., 'utils', 'components', etc.
 * @returns A debug logger instance that can be used to log messages.
 * Example usage:
 * const logger = createDebugger('pages:components:richTextEditor:cardLink');
 * logger('This is a debug message');
 * This will log messages to the console with the prefix 'app:pages:components:richTextEditor:cardLink'.
 * You can enable debug logging in browser by setting the debug local storage: localStorage.debug = 'app:pages:components:richTextEditor:cardLink'
 * This will enable logging for the specified namespace.
 * You can also use wildcards to enable multiple namespaces, e.g., localStorage.debug = 'app:cqrs:*,app:utils:*,pages:components:richTextEditor:cardLink'
 * or localStorage.debug = 'app:*' to enable all logs.
 * This allows you to filter logs based on the namespace you are interested in.
 */
export const createDebugger = (namespace: string) => {
    const logger = debug(`app:${namespace}`);
    return logger;
};

//print out the localStorage.debug value to console
if (localStorage.debug && localStorage.debug.length > 0) {
    console.log('%c========== Debugging Messages Enabled ==========', 'color: red; font-weight: bold; background-color: black;');
    console.log('Namespaces:', localStorage.debug);
    console.log('%c================================================', 'color: red; font-weight: bold; background-color: black;');
} else {
    console.log('%c========== Debugging Messages Disabled ==========', 'color: red; font-weight: bold; background-color: black;');
}
